import Home from "./pages/home";
import DetalleMutuo from "./features/detalleMutuo/pages/detalleMutuo";
import CarteraTotal from "./features/carteraTotal/pages/carteraTotal";
import Inmobiliarias from "./features/maestros/inmobiliarias/pages/inmobiliarias";
import BandejaMutuos from "./features/bandejaMutuos/pages/bandejaMutuos";
import CompaniasSeguro from "./features/maestros/companiasSeguro/pages/companiasSeguro";
import Maestros from "./features/maestros/administracionMaestros/pages/maestros";
import Responsables from "./features/maestros/responsables/pages/responsables";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { AccountBalance, AllInboxTwoTone, SettingsApplicationsTwoTone, DocumentScanner, HomeWork, Handshake, Money, Payments, ReceiptLong } from "@mui/icons-material";
import EjecutadorQuery from "./features/ejecutadorQuery/page/ejecutadorQuery";
import Tasa from "./features/maestros/tasas/pages/tasa";
import Liquidacion from "./features/liquidacion/pages/liquidacion";
import Prepago from "./features/prepago/pages/prepagos";
import Dividendo from "./features/dividendo/pages/dividendo";
import DividendosMes from "./features/reportes/dividendosMes/pages/dividendosMes";
import Reportes from "./features/reportes/administracionReportes/reportes";
import ConsultarMovimientosContables from "./features/reportes/consultarMovimientosContables/page/consultarMovimientosContables";
import GenerarProcesosMasivos from "./features/reportes/generarProcesosMasivos/pages/generarProcesosMasivos";
import RecaudacionMasiva from "./features/recaudacionMasiva/administracionRecaudacionMasiva/recaudacionMasiva";
import AdministradorPac from "./features/recaudacionMasiva/administradorPac/page/administradorPac";
import AdministradorPat from "./features/recaudacionMasiva/administradorPat/page/administradorPat";
import ArchivoPac from "./features/recaudacionMasiva/archivoPacPat/pages/archivoPac";
import MinvuPage from "./features/minvu/administracionMinvu/page/minvuPage";
import ValidarBeneficio from "./features/minvu/validarBeneficios/page/validarBeneficio";
import PermMediaIcon from '@mui/icons-material/PermMedia';
import ConsultaOCM from "./features/recaudacionMasiva/consultaOcm/pages/consultaOcm";
import CobradorMinvu from "./features/minvu/cobradorMinvu/page/cobradorMinvu";
import ContabilidadPage from "./features/contabilidad/principal/pages/contabilidadPage";
import ValidadorAsientosContables from "./features/contabilidad/validadorAsientos/pages/validadorAsientos";
import AnalizarMovimientosContables from "./features/contabilidad/validadorAsientos/pages/analizarMovimientosContables";
import ResumenEnviados from "./features/contabilidad/validadorAsientos/pages/resumenEnviados";
import DetalleDescuadrados from "./features/contabilidad/validadorAsientos/pages/detalleDescuadrados";
import RegistrarRecaudacion from "./features/recaudacionMasiva/registrarRecaudacionMasiva/page/registrarRecaudacion";
import GeneracionMasiva from "./features/endosos/generacionmasiva/pages/generacionMasiva";
import CargaValidacion from "./features/minvu/respuestaCargaVal/page/cargaValidacion";
import CargaCobro from "./features/minvu/cargaCobro/page/cargaCobro";
import EndosoMasivo from "./features/endosos/endososMasivos/pages/endosoMasivo";
import CobroSeguro from "./features/minvu/archivoMinvuCesantia/page/cobroSeguro";
import AdministracionRemesas from "./features/remesas/administracionRemesas/page/administracionRemesas";
import ConsultarRemesas from "./features/remesas/consultarRemesas/page/consultarRemesas";
import EndososPSM from "./features/endosos/endososPsm/pages/endososPsm";
import AdministracionEndosos from "./features/endosos/administracionEndosos.tsx/AdministracionEndosos";
import ClientesCesantes from "./features/maestros/clientesCesantes/page/clientesCesantes";
import TablaDesarrollo from "./features/maestros/tablasDesarrollo/pages/tablaDesarrollo";
import ImportTablaDesarrollo from "./features/maestros/tablasDesarrollo/pages/importTablaDesarrollo";
import CobranzaJudicial from "./features/maestros/cobranzaJudicial/page/cobranzaJudicial";
import DetalleTablaDesarrollo from "./features/maestros/tablasDesarrollo/pages/detalleTablaDesarrollo";
import LiquidacionDeuda from "./features/reportes/liquidacionDeuda/pages/liquidacionDeuda";
import InformeDesg from "./features/remesas/reporteRemesasDes/page/informeDesg";
import InfomesCMF from "./features/reportes/informesCMF/page/informesCMF";
import CertificadoSii from "./features/reportes/certificadoSII/pages/certificadoSII";
import ActualizacionDeuda from "./features/reportes/actualizacionDeuda/pages/actualizacionDeuda";
import DeclaracionJurada from "./features/reportes/declaracionJurada/pages/declaracionJurada";
import PageRecaudacionDiaria from "./features/reportes/recaudacionDiaria/page/pageRecaudacionDiaria";
import InformeDICOM from "./features/reportes/informeDICOM/pages/informeDICOM";
import CorreccionMonetaria from "./features/maestros/correccionmonetaria/pages/correccionMonetaria";
import ReporteDividendoRecaudacion from "./features/contabilidad/dividendosRecaudados/pages/reporteDividendoRecaudados";
import PolizaSeguro from "./features/maestros/polizaSeguro/page/polizaSeguro";
import InstitucionFinanciera from "./features/maestros/institucionFinanciera/page/institucionFinanciera";
import ArchivoEndosoPms from "./features/reportes/endosoPms/pages/archivoEndosoPms";
import MorososServinco from "./features/recaudacionMasiva/morososServinco/pages/morososServinco";
import Cobranzas from "./features/cobranzas/administradorCobranzas/cobranzas";
import DividendosImpagos from "./features/dividendo/components/dividendosImpagos";
import Dividendos from "./features/dividendo/components/dividendos";
import { PermissionGuard } from "./components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "./utils/enums";
import { permission } from "process";

const rutasMenu = [
    {
        url: '/bandeja-mutuos',
        icon: <AllInboxTwoTone />,
        name: 'Bandeja mutuos',
        permission: [TipoFuncionalidad.Bandeja_ver],
        subMenus: [],
        id: "li-bandeja-mutuos"
    },
    {
        url: '/cartera-mutuos/',
        icon: <AccountBalance />,
        name: 'Cartera mutuos',
        permission: [TipoFuncionalidad.Cartera_ver],
        subMenus: [],
        id: "li-cartera-mutuos"
    },
    {
        url: '/endosos/',
        icon: <Handshake />,
        name: 'Endosos masivos',
        permission: [TipoFuncionalidad.Endoso_masivo],
        subMenus: [],
        id: 'endosos-masivos'
    },
    {
        url: '/remesas/',
        icon: <Payments />,
        name: 'Remesas',
        permission: [TipoFuncionalidad.Remesas_ADM],
        subMenus: [],
        id: "li-remesas"
    },
    {
        url: '/recaudacionMasiva/',
        icon: <PermMediaIcon />,
        name: 'Recaudación masiva',
        permission: [TipoFuncionalidad.Recaudacion_ver],
        subMenus: [],
        id: "li-recaudacion"
    },
    {
        url: '/cobranzas/',
        icon: <ReceiptLong />,
        name: 'Cobranzas',
        permission: [TipoFuncionalidad.Cobranza_ver],
        subMenus: [],
        id: "li-cobranzas"
    },
    {
        url: '/contabilidad/',
        icon: <Money />,
        name: 'Contabilidad',
        permission: [TipoFuncionalidad.Conta_ver_Divs, TipoFuncionalidad.Conta_ver_movs, TipoFuncionalidad.Contailidad_ADM],
        subMenus: [],
        id: "li-contabilidad"
    },
    {
        url: '/minvu/',
        icon: <HomeWork />,
        name: 'MINVU',
        permission: [TipoFuncionalidad.Minvu_ADM],
        subMenus: [],
        id: "li-minvu"
    },
    {
        url: '/reportes/',
        icon: <DocumentScanner />,
        name: 'Reportes',
        permission: [TipoFuncionalidad.Reporte_consultas],
        subMenus: [],
        id: "li-reportes"
    },
    {
        url: '/ejecutar-query/',
        icon: <AssignmentIcon />,
        name: 'Ejecutador querys',
        permission: [TipoFuncionalidad.Ejecutar_query],
        subMenus: [],
        id: "li-ejecutar-query"
    },
    {
        url: '/maestros/',
        icon: <SettingsApplicationsTwoTone />,
        name: 'Maestros',
        permission: [TipoFuncionalidad.Maestros_ver],
        subMenus: [],
        id: "li-maestros"
    },
]

const rutasRouter = [
    {
        path: '/home',
        element: <Home />
    },
    {
        path: '/',
        element: <Home />
    },
    {
        path: '/bandeja-mutuos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Bandeja_ver]}>
                <BandejaMutuos />
            </PermissionGuard>
        )
    },
    {
        path: '/mutuos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cartera_ver, TipoFuncionalidad.Bandeja_ver]}>
                <DetalleMutuo />
            </PermissionGuard>
        )
    },
    {
        path: '/mutuos/liquidacion',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cartera_liq_ver]}>
                <Liquidacion />
            </PermissionGuard>
        )
    },
    {
        path: '/mutuos/prepagos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cartera_prep_ver]}>
                <Prepago />
            </PermissionGuard>
        )
    },
    {
        path: '/contabilidad/',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Conta_ver_Divs, TipoFuncionalidad.Conta_ver_movs, TipoFuncionalidad.Contailidad_ADM]}>
                <ContabilidadPage />
            </PermissionGuard>
        )
    },
    {
        path: '/contabilidad/consultarMovimientosContables',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Conta_ver_movs]}>
                <ConsultarMovimientosContables />
            </PermissionGuard>
        )
    },
    {
        path: '/contabilidad/validadorAsientos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Contailidad_ADM]}>
                <ValidadorAsientosContables />
            </PermissionGuard>
        )
    },
    {
        path: '/contabilidad/validadorAsientos/analizarMovimientosContables',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Contailidad_ADM]}>
                <AnalizarMovimientosContables />
            </PermissionGuard>
        )
    },
    {
        path: '/contabilidad/validadorAsientos/analizarMovimientosContables/resumenEnviados',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Contailidad_ADM]}>
                <ResumenEnviados />
            </PermissionGuard>
        )
    },
    {
        path: '/contabilidad/validadorAsientos/analizarMovimientosContables/detalleDescuadrados',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Contailidad_ADM]}>
                <DetalleDescuadrados />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/inmobiliarias',
        element:
            (<PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <Inmobiliarias />
            </PermissionGuard>)
    },
    {
        path: '/cartera-mutuos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cartera_ver]}>
                <CarteraTotal />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/companias-seguro',
        element:
            (<PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <CompaniasSeguro />
            </PermissionGuard>)
    },
    {
        path: '/maestros',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <Maestros />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/responsables',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <Responsables />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/tabla-desarrollo',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <TablaDesarrollo />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/tabla-desarrollo/importar',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <ImportTablaDesarrollo />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/tabla-desarrollo/detalle',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <DetalleTablaDesarrollo />
            </PermissionGuard>
        )
    },
    {
        path: '/ejecutar-query',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Ejecutar_query]}>
                <EjecutadorQuery />
            </PermissionGuard>
        )
    },
    {
        path: '/maestros/tasa',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <Tasa />
            </PermissionGuard>
        )
    },
    {
        path: '/mutuos/dividendo',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cartera_ver]}>
                <Dividendo activeTab={1} />
            </PermissionGuard>
        )
    },
    {
        path: '/reportes',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reporte_consultas]}>
                <Reportes />
            </PermissionGuard>
        )
    },
    {
        path: '/reportes/dividendos-mes',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reporte_consultas]}>
                <DividendosMes />
            </PermissionGuard>
        )
    },
    {
        path: '/cobranzas/generarProcesosMasivos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                <GenerarProcesosMasivos />
            </PermissionGuard>
        )
    },
    {
        path: '/reportes/endosoPms',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reporte_consultas]}>
                <ArchivoEndosoPms />
            </PermissionGuard>
        )
    },
    {
        path: 'recaudacionMasiva',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_ver]}>
                <RecaudacionMasiva />
            </PermissionGuard>
        )
    },
    {
        path: 'cobranzas',
        element:
            (<PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                <Cobranzas />
            </PermissionGuard>)
    },
    {
        path: 'recaudacionMasiva/administrarPac',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_ver]}>
                <AdministradorPac />
            </PermissionGuard>
        )
    },
    {
        path: '/recaudacionMasiva/archivoPac',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_ver]}>
                <ArchivoPac />
            </PermissionGuard>
        )
    },
    {
        path: '/cobranzas/morosos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                <MorososServinco />
            </PermissionGuard>
        )
    },
    {
        path: '/recaudacionMasiva/archivoPat',
        element:
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_adm]}>
                <ArchivoPac />
            </PermissionGuard>
    },
    {
        path: 'recaudacionMasiva/administrarPat',
        element:
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_adm]}>
                <AdministradorPat />
            </PermissionGuard>
    },
    {
        path: 'recaudacionMasiva/consultarOCM',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_adm]}>
                <ConsultaOCM />
            </PermissionGuard>
        )
    },
    {
        path: '/minvu',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Minvu_ADM]}>
                <MinvuPage />
            </PermissionGuard>
        )
    },
    {
        path: '/minvu/beneficios',

        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Minvu_ADM]}>
                <ValidarBeneficio />
            </PermissionGuard>
        )
    },
    {
        path: '/minvu/cobrar-beneficios',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Minvu_ADM]}>
                <CobradorMinvu />
            </PermissionGuard>
        )
    },
    {
        path: '/endosos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                <AdministracionEndosos />
            </PermissionGuard>
        )
    },
    {
        path: '/endosos/endosos-masivos',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                <EndosoMasivo />
            </PermissionGuard>
        )
    },
    {
        path: '/endosos/endosos-masivos/generacion-masiva',
        element:
            (
                <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                    <GeneracionMasiva />
                </PermissionGuard>
            )
    },
    {
        path: '/endosos/endosos-psm',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                <EndososPSM />
            </PermissionGuard>
        )
    },
    {
        path: '/endosos/archivo-endosos-psm',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                <ArchivoEndosoPms />
            </PermissionGuard>
        )
    },
    {
        path: '/minvu/respuesta-validacion',
        element: (

            <PermissionGuard permissions={[TipoFuncionalidad.Minvu_ADM]}>
                <CargaValidacion />
            </PermissionGuard>)
    },
    {
        path: '/minvu/respuesta-cobro',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Minvu_ADM]}>
                <CargaCobro />
            </PermissionGuard>
        )
    },
    {
        path: '/minvu/seguro-cesantia',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Minvu_ADM]}>
                <CobroSeguro />
            </PermissionGuard>
        )
    },
    {
        path: '/recaudacionMasiva/registrarRecaudacion',
        element:
            <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_adm]}>
                <RegistrarRecaudacion />
            </PermissionGuard>
    },
    {
        path: '/remesas',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Remesas_ADM]}>
                <AdministracionRemesas />
            </PermissionGuard>
        )
    },
    {
        path: '/remesas/consultar',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Remesas_ADM]}>
                <ConsultarRemesas />
            </PermissionGuard>
        )
    },
    {
        path: '/remesas/informeDesg',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Remesas_ADM]}>
                <InformeDesg />
            </PermissionGuard>
        )
    },
    {
        path: '/cobranzas/clientes-cesantes',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                <ClientesCesantes />
            </PermissionGuard>
        )
    },
    {
        path: '/cobranzas/cobranza-judicial',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                <CobranzaJudicial />
            </PermissionGuard>
        )
    },
    {
        path: '/cobranzas/informeDicom',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_adm]}>
                <InformeDICOM />
            </PermissionGuard>
        )
    },
    {
        path: '/certificadosPortabilidad/liquidacionDeuda',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reportes_portabilidad]}>
                <LiquidacionDeuda />
            </PermissionGuard>
        )
    },
    {
        path: '/certificadosPortabilidad/actualizacionDeuda',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reportes_portabilidad]}>
                <ActualizacionDeuda />
            </PermissionGuard>
        )
    },
    {
        path: 'reportes/informes-cmf',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reportes_CMF]}>
                <InfomesCMF />
            </PermissionGuard>
        )
    },
    {
        path: 'reportes/certificados-sii',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reportes_SII]}>
                <CertificadoSii />
            </PermissionGuard>
        )
    },
    {
        path: 'reportes/declaracion-jurada-sii',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reportes_SII]}>
                <DeclaracionJurada />
            </PermissionGuard>
        )
    },
    {
        path: 'reportes/recaudacion-diaria',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Reporte_consultas]}>
                <PageRecaudacionDiaria />
            </PermissionGuard>
        )
    },
    {
        path: 'maestros/correccion-monetaria',
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <CorreccionMonetaria />
            </PermissionGuard>
        )
    },
    {
        path: "contabilidad/dividendos-recaudados",
        element:
            (<PermissionGuard permissions={[TipoFuncionalidad.Conta_ver_Divs]}>
                <ReporteDividendoRecaudacion />
            </PermissionGuard>)
    },
    {
        path: "contabilidad/dividendos-no-recaudados",
        element: (<PermissionGuard permissions={[TipoFuncionalidad.Conta_ver_Divs]}>
            <ReporteDividendoRecaudacion />
        </PermissionGuard>)
    },
    // {
    //     path: "reportes/dividendos-no-recaudados",
    //     element: <ReporteDividendoRecaudacion />
    // },
    {
        path: "maestros/poliza-seguro",
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <PolizaSeguro />
            </PermissionGuard>
        )
    },
    {
        path: "maestros/institucion-financiera",
        element: (
            <PermissionGuard permissions={[TipoFuncionalidad.Maestros_ver]}>
                <InstitucionFinanciera />
            </PermissionGuard>
        )
    },


]

export { rutasMenu, rutasRouter };